import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./state";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/style.css";
import "./assets/css/swal-theme.css";
import "./assets/css/text-color-overrides.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const app = createApp(App);

app.use(store);
app.use(router);

app.mount("#app");
